import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=72d854aa&scoped=true&"
import script from "./ReportsPage.vue?vue&type=script&lang=js&"
export * from "./ReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d854aa",
  null
  
)

export default component.exports